// Registration spans multiple page loads (the user leaves to click a link in
// their verification email), so the invoice's returnURL can't be carried via
// redux/router state alone - it has to survive in localStorage.
const STORAGE_KEY = "postRegistrationRedirect";

export const setPostRegistrationRedirect = returnURL => {
  if (!returnURL?.url) {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(returnURL));
  } catch (err) {
    // ignore storage errors (e.g. private browsing / storage disabled)
  }
};

export const getPostRegistrationRedirect = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (err) {
    return null;
  }
};

export const clearPostRegistrationRedirect = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    // ignore storage errors (e.g. private browsing / storage disabled)
  }
};
